'use client';

import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { DEFAULT_PRODUCT_BRAND_NAME } from '@terra/shared-utils';

export type UiBranding = {
  brandName: string;
  logoUrl: string | null;
  faviconUrl: string | null;
  isWhiteLabeled: boolean;
  supportEmail?: string | null;
  publicWebsite?: string | null;
};

const DEFAULT_BRANDING: UiBranding = {
  brandName: DEFAULT_PRODUCT_BRAND_NAME,
  logoUrl: null,
  faviconUrl: null,
  isWhiteLabeled: false,
};

const BrandingContext = createContext<UiBranding>(DEFAULT_BRANDING);

export function BrandingProvider({
  children,
  value,
}: {
  children: ReactNode;
  value?: UiBranding;
}) {
  return (
    <BrandingContext.Provider value={value ?? DEFAULT_BRANDING}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding(): UiBranding {
  return useContext(BrandingContext);
}
